import React from 'react';
import { getColors } from '../../../../../constants/colors';
import { MB_ToggleSwitch } from '@mightybyte/rnw.components.toggle-switch';

interface Props {
    isToggled: boolean;
    onToggle: (bool: boolean) => void;
}
const COLORS = getColors();

export function Switch({ isToggled, onToggle }: Props) {
    return (
        <MB_ToggleSwitch
            isToggled={isToggled}
            onToggle={onToggle}
            trackBar={{
                height: 20,
                width: 40,
                radius: 10,
                activeBackgroundColor: COLORS.orange,
                inActiveBackgroundColor: '#E0E0E0',
                borderActiveColor: COLORS.orange,
                borderInActiveColor: '#E0E0E0',
            }}
            thumbButton={{
                width: 20,
                height: 20,
                radius: 10,
                activeBackgroundColor: COLORS.white,
                inActiveBackgroundColor: COLORS.white,
                activeColor: COLORS.white,
                inActiveColor: COLORS.white,
            }}
            animationDuration={200}
            thumbStyle={{
                elevation: 2,
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.2,
                shadowRadius: 1,
            }}
            trackBarStyle={{
                marginVertical: 0,
            }}
        />
    );
}
